export default __webpack_public_path__ + "static/media/home-video.ef6ea5a9.png";